import { css } from 'styled-components';
import { CFBaseNumberBadgeHelpers } from './styles';
import { CFTokens } from '../../../tokens';
export const CFBaseNumberBadgeStyles = {
    Root: css `
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${CFBaseNumberBadgeHelpers.rootBackground};
    border: 0.5px solid ${CFBaseNumberBadgeHelpers.rootBorder};
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    ${CFBaseNumberBadgeHelpers.rootPadding};
    ${CFBaseNumberBadgeHelpers.rootSize};
  `,
    Value: css `
    text-align: center;
    color: ${CFBaseNumberBadgeHelpers.valueColor};
    ${CFBaseNumberBadgeHelpers.valueTypeSpec};
  `,
};
